/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 16:39:40
 * @LastEditors: Jack Deng
 * @LastEditTime: 2023-03-14 17:48:45
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import Filter from './Filter'; //, { EnumFilterType }
import Search from './SearchInput';
import Sort from './Sort';
import Tags from './Tags';
//import { salesChannelFilter } from 'src/constrains/Query1/Filter/PreConfig/SalesChannel';

// const filters = [
//   {
//     type: EnumFilterType.Range,
//     keyWord: 'Range',
//     dropdownProps: { name: 'Range', maxWidth: 400, maxHeight: 400 },
//   },
//   {
//     type: EnumFilterType.SingleSelection,
//     options: [
//       { value: 'z', label: 'zxczxczxczxczxczxczxczxczx' },
//       { value: 'x', label: 'x' },
//     ],

//     keyWord: 'Single',
//     dropdownProps: { name: 'Single', maxWidth: 100 },
//   },
//   {
//     type: EnumFilterType.MultipleSelection,
//     options: [
//       { value: 'z', label: 'zxczxczxczxczxczxczxczxczx' },
//       { value: 'x', label: 'x' },
//     ],

//     keyWord: 'Multi',
//     dropdownProps: { name: 'Multi', maxWidth: 100 },
//   },
//   {
//     type: EnumFilterType.Cascader,
//     keyWord: 'Cascader',
//     options,
//     dropdownProps: { name: 'Cascader', maxWidth: 500 },
//   },
//   salesChannelFilter(options),
// ];

export enum EnumQueryType {
  search = 'search',
  filter = 'filter',
  sort = 'sort',
  closeTag = 'closeTag',
}

const Query = (props) => {
  const {
    data,
    onSearchChange,
    onFilterChange,
    onSortChange,
    onTagClose,
    filters = [],
    sortList = [],
    wrapperClassName,
    searchPlaceholder,
  } = props;

  const { search = [], filter = {}, sort = {} } = data || {};

  const generateTagsValue = () => {
    const searchValue = search.map((i) => {
      return { ...i, queryType: EnumQueryType.search };
    });
    const filterArr = [];
    Object.keys(filter).forEach((key) => {
      filterArr.push(
        ...(filter[key].map((i) => {
          return { queryType: EnumQueryType.filter, key, ...i };
        }) || []),
      );
      // return { ...filter[i], queryType: EnumQueryType.filter, key: i };
    });

    return [...searchValue, ...filterArr];
  };
  const tags = generateTagsValue();

  return (
    <div className={`${css.wrapper} ${wrapperClassName || ''}`}>
      <div className={css.container}>
        <div className={css.inputContainer}>
          <Search
            onPress={onSearchChange}
            onSearch={onSearchChange}
            existingData={search}
            placeholder={searchPlaceholder}
          />
        </div>
        <div className={css.filterContainer}>
          {filters.length > 0 && (
            <Filter onChange={onFilterChange} filters={filters} data={filter} />
          )}
        </div>
        {sortList.length > 0 && (
          <Sort onChange={onSortChange} data={sort} sortList={sortList} />
        )}
      </div>
      {tags.length > 0 && (
        <div className={css.tagContainer}>
          <Tags onClose={onTagClose} data={tags} />
        </div>
      )}
    </div>
  );
};
export default Query;
